import React, { Component } from 'react';
import cookie from 'react-cookies';

import { btnTypes } from '../../buttons/baseButton';
import { dataLayerPush } from '../../helpers';
import { Button, Content, TooltipCity, TooltipFooter, TooltipTitle, TooltipWrapper } from './styled';

// Для использования требуется наличие NEXT_PUBLIC_COOKIE_DOMAIN в env
export const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN;

class CitySelection extends Component {
    state = {
        show: false,
    }

    gaCityShow() {
        if (window && window.sessionStorage.getItem('GA') !== '1') {
            window.sessionStorage.setItem('GA', '1');

            dataLayerPush({
                event: 'UAevent',
                category: 'City Choice',
                action: 'Show',
            });
        }
    }

    componentDidMount() {
        if (this.props.isAuth || !!cookie.load('cityconfirm')) {
            this.setState({ show: false });
        } else {
            this.setState({ show: true });
            this.gaCityShow();
        }
    }

    componentDidUpdate({ isAuth }) {
        if (isAuth !== this.props.isAuth && this.props.isAuth) {
            this.setState({ show: false });
        }
    }

    handleClick = () => {
        const expires = new Date();
        expires.setDate(expires.getDate() + 41);

        cookie.save('cityconfirm', 1, {
            expires,
            domain: COOKIE_DOMAIN,
            path: '/',
        });

        this.setState({ show: false }, () => {
            typeof this.props.onClose === 'function' && this.props.onClose();
        });
    }

    noBtnClick = () => {
        this.setState({ show: false }, () => this.props.onBackClick());
    }

    render() {
        const { isOpen = this.state.show, city, className } = this.props;

        return (
            <TooltipWrapper className={className} show={isOpen} >
                <Content>
                    <TooltipTitle>Ваш город</TooltipTitle>
                    <TooltipCity>{city.name}</TooltipCity>
                </Content>
                <TooltipFooter>
                    <Button onClick={this.noBtnClick} type={btnTypes.SECONDARY} >
                        Нет, другой
                    </Button>
                    <Button onClick={this.handleClick} className='js__tooltip-city_close'>
                        Да, спасибо
                    </Button>
                </TooltipFooter>
            </TooltipWrapper>
        );
    }
}

export default CitySelection;
